import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstanceJson from "../../../AxiosInstance/axiosInstanceJson";

export const createDistrict = createAsyncThunk(
  "District/createDistrict",
  async (districtData, { rejectWithValue }) => {
    try {
      const response = await axiosInstanceJson.post(
        "/v1/admin/district/create-district",
        districtData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getDistrict = createAsyncThunk(
  "District/getDistrict",
  async (
    {
      id,
      status = "All",
      search = "",
      page = 1,
      limit = 10,
      startDate,
      endDate,
      paginate,
    },
    thunkAPI
  ) => {
    try {
      const { data } = await axiosInstanceJson.get(
        "/v1/admin/district/get-district",
        {
          params: {
            id,
            status,
            search,
            page,
            limit,
            startDate,
            endDate,
            paginate,
          },
        }
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Error occurred");
    }
  }
);

export const updateDistrict = createAsyncThunk(
  "District/updateDistrict",
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const response = await axiosInstanceJson.put(
        `/v1/admin/district/update-district/${id}`,
        formData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteDistrict = createAsyncThunk(
  "District/deleteDistrict",
  async (id, thunkAPI) => {
    try {
      const { data } = await axiosInstanceJson.put(
        `/v1/admin/district/delete-district/${id}`
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const undoDeleteDistrict = createAsyncThunk(
  "District/undoDeleteDistrict",
  async (id, thunkAPI) => {
    try {
      const { data } = await axiosInstanceJson.put(
        `/v1/admin/district/undodelete-district/${id}`
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getDistrictById = createAsyncThunk(
  "District/getById",
  async (id, thunkAPI) => {
    try {
      const { data } = await axiosInstanceJson.get(
        `/v1/admin/district/getSingle-district/${id}`
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getDistrictByState = createAsyncThunk(
  "State/getById",
  async (stateId, thunkAPI) => {
    try {
      const { data } = await axiosInstanceJson.get(
        `/v1/admin/district/stateBy-district/${stateId}`
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);
